import { registerLicense } from "@syncfusion/ej2-base";

// Register the Syncfusion license key once at app startup. In production, the
// key is fetched from an authenticated endpoint — never embedded in a public
// bundle. For local dev this falls back to a Vite env var so a developer can
// paste their personal key into a gitignored `.env.local`.
export function initSyncfusion(): void {
    const key = import.meta.env.VITE_SYNCFUSION_LICENSE_KEY;
    if (key && key.length > 0) {
        registerLicense(key);
    }
    // With no key, Syncfusion shows a trial banner but all components work.
}
